import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Star, ArrowLeft, ArrowRight } from "lucide-react";
import { EXTRAS, TESTIMONIALS } from "../../mock";
import { useMedia, resolveUrl } from "../../context/MediaContext";
import { KineticText, Reveal, EASE } from "../../lib/motion";

export default function NightSpa() {
  const { slots } = useMedia();
  const [idx, setIdx] = useState(0);
  const t = TESTIMONIALS[idx];
  const go = (d) => setIdx((p) => (p + d + TESTIMONIALS.length) % TESTIMONIALS.length);

  return (
    <section className="relative py-28 px-6">
      <div className="max-w-[1300px] mx-auto w-full">
        <div className="text-center mb-14">
          <Reveal>
            <span className="font-body text-xs tracking-[0.35em] uppercase text-white/60">Nightfall &middot; 10:20 PM</span>
          </Reveal>
          <h2 className="font-display font-extrabold text-white leading-[0.9] text-6xl md:text-8xl mt-3">
            <KineticText text="After" />
            <span className="font-serif-i italic font-normal text-[var(--amber-light)]"> dark</span>
          </h2>
          <Reveal delay={0.1}>
            <p className="text-white/60 max-w-xl mx-auto mt-5 font-light">
              When the sun dips below the pergolas, the house glows. Every thoughtful detail is
              already taken care of &mdash; just relax.
            </p>
          </Reveal>
        </div>

        {/* Night bento of the "even more" spaces */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {EXTRAS.map((e, i) => (
            <Reveal key={e.title} delay={(i % 4) * 0.08}>
              <motion.div whileHover={{ y: -10 }} className="group relative rounded-[24px] overflow-hidden h-72 border border-white/10">
                <img src={resolveUrl(slots[e.imgKey])} alt={e.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#04140E] via-[#04140E]/30 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-5">
                  <h3 className="font-display font-bold text-white text-xl">{e.title}</h3>
                  <p className="text-white/65 text-[12px] leading-relaxed mt-2 max-h-0 opacity-0 group-hover:max-h-40 group-hover:opacity-100 transition-all duration-500 overflow-hidden">{e.text}</p>
                </div>
                <span className="absolute top-4 right-4 w-1.5 h-1.5 rounded-full bg-[var(--amber)] shadow-[0_0_10px_var(--amber)]" />
              </motion.div>
            </Reveal>
          ))}
        </div>

        {/* Guest review under the stars */}
        <div className="mt-20 max-w-3xl mx-auto text-center relative min-h-[220px]">
          <AnimatePresence mode="wait">
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.5, ease: EASE }}
            >
              <div className="flex justify-center gap-1 mb-5">
                {Array.from({ length: t.rating }).map((_, s) => (<Star key={s} size={18} className="fill-[var(--amber)] text-[var(--amber)]" />))}
              </div>
              <p className="font-serif-i italic text-white text-2xl md:text-3xl leading-relaxed">&ldquo;{t.text}&rdquo;</p>
              <p className="mt-6 font-display font-bold text-[var(--amber-light)]">{t.name}</p>
              <p className="text-white/50 text-sm">{t.location}</p>
            </motion.div>
          </AnimatePresence>
          <div className="flex items-center justify-center gap-4 mt-8">
            <button onClick={() => go(-1)} data-cursor="hover" className="w-11 h-11 rounded-full border border-white/25 grid place-items-center text-white hover:bg-white hover:text-[#04140E] transition-all"><ArrowLeft size={18} /></button>
            <button onClick={() => go(1)} data-cursor="hover" className="w-11 h-11 rounded-full border border-white/25 grid place-items-center text-white hover:bg-white hover:text-[#04140E] transition-all"><ArrowRight size={18} /></button>
          </div>
        </div>
      </div>
    </section>
  );
}
